import {
  GET_BASE_DATA, RESET_BASE_DATA, RESET_FEED_DATA, RESET_APP_LOADER, RESET_FORM_ERRORS,
  DELETE_FEED_ITEM, SAVE_USER_PUSH_NOTIFICATION_TOKEN, USER_SESSION_EXPIRED,
} from '../../constants/system/actions';

const getBaseData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_BASE_DATA, payload, resolve, reject,
});

const resetBaseData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_BASE_DATA, payload,
});

const resetAppLoader: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_APP_LOADER, payload,
});

const resetFeedData: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_FEED_DATA, payload,
});

const resetFormErrors: Function = (payload?: ActionPayload): ReduxAction => ({
  type: RESET_FORM_ERRORS, payload,
});

const deleteFeedItem: Function = (payload?: ActionPayload): ReduxAction => ({
  type: DELETE_FEED_ITEM, payload,
});

const saveUserPushNotificationToken: Function = (
  payload?: ActionPayload, resolve?: Function, reject?: Function,
): ReduxAction => ({
  type: SAVE_USER_PUSH_NOTIFICATION_TOKEN, payload, resolve, reject,
});

const userSessionExpired: Function = (payload?: ActionPayload): ReduxAction => ({
  type: USER_SESSION_EXPIRED, payload,
});

export {
  getBaseData,
  resetBaseData,
  resetAppLoader,
  resetFeedData,
  resetFormErrors,
  deleteFeedItem,
  saveUserPushNotificationToken,
  userSessionExpired,
};
